import { waUrl, DEFAULT_WA_TEXT } from "@/lib/whatsapp";

export const CTAWhatsAppButton = ({ text = DEFAULT_WA_TEXT, label = "Hablar con un asesor", variant = "outline", track, className = "", testId }) => (
  <a
    href={waUrl(text)}
    target="_blank"
    rel="noopener noreferrer"
    className={`btn-mt btn-mt-${variant} ${className}`}
    data-track={track}
    data-testid={testId}
  >
    <i className="fab fa-whatsapp text-xl" aria-hidden="true" /> {label}
  </a>
);

export default CTAWhatsAppButton;
